import type { TranslationDict } from '../en';

const hu: TranslationDict = {
  'header.buy': 'Vásárlás',
  'header.sell': 'Eladás',
  'spend.label': 'Ön fizet',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Ön kap',
  'payment.label': 'Fizetési mód',
  'payment.select': 'Kiválasztás',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Ehhez a párhoz nincs elérhető fizetési mód',
  'wallet.label': 'Fogadó tárca címe',
  'wallet.placeholderBuy': 'Adja meg a fogadó címét',
  'wallet.placeholderSell': 'Adja meg a küldő címét',
  'wallet.validating': 'Cím ellenőrzése...',
  'wallet.invalid': 'Adjon meg érvényes tárcacímet',
  'wallet.invalidServer': 'Érvénytelen tárcacím',
  'cta.buy': '{crypto} vásárlása',
  'cta.sell': '{crypto} eladása',
  'cta.gettingPrice': 'A legjobb ár keresése...',
  'cta.processing': 'Feldolgozás...',
  'footer.poweredBy': 'Powered by ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Árfolyam részletei',
  'rate.close': 'Bezárás',
  'rate.updatesIn': 'Az árfolyam frissül: 00:{seconds}',
  'rate.noQuote': 'Nem érhető el ajánlat',
  'rate.exchangeRate': 'Árfolyam',
  'rate.processingFee': 'Feldolgozási díj',
  'rate.networkFee': 'Hálózati díj',
  'rate.provider': 'Szolgáltató',
  'toast.orderCreated': 'Rendelés létrehozva',
  'toast.redirecting': 'Átirányítás a fizetéshez...',
  'toast.orderFailed': 'A rendelés sikertelen',
  'toast.couldNotCreate': 'A rendelés nem hozható létre',
  'toast.quoteError': 'Ajánlat hiba',
  'toast.noProviders': 'Nincs elérhető szolgáltató',
  'toast.somethingWrong': 'Valami hiba történt',
  'error.amountZero': 'Az összegnek nagyobbnak kell lennie 0-nál',
  'error.minAmountFiat': 'A minimális összeg {min} {currency}',
  'error.minAmountCrypto': 'A minimális összeg {min} {currency}',
  'error.noProviders': 'Ehhez a kombinációhoz nincs elérhető szolgáltató',
  'error.currencyUnavailableBuy': 'Ez a deviza nem érhető el vásárláshoz',
  'error.currencyUnavailableSell': 'Ez a deviza nem érhető el eladáshoz',
  'parity.info': 'A terhelés {receiveAmount} {crypto} összegre vonatkozik, a fennmaradó {spendAmount} {fiat} összeg a {partner} fiókjára kerül jóváírásra',
  'redirect.secureBadge': 'Biztonságos fizetés',
  'redirect.title': 'Fizetés folytatása',
  'redirect.description': 'A fizetés befejezéséhez átirányítjuk a következőhöz: {gateway}.',
  'redirect.countdown': 'Átirányítás {seconds} másodperc múlva...',
  'redirect.openTab': 'ACH megnyitása új lapon',
  'redirect.cancel': 'Mégse',
  'checkout.noOrder': 'Nem található rendelés',
  'checkout.goBack': 'Vissza',
  'checkout.expired': 'A munkamenet lejárt',
  'checkout.expiredDesc': 'A munkamenet lejárt. Kérjük, próbálja újra.',
  'checkout.startOver': 'Kezdje elölről',
  'checkout.cancel': 'Mégse',
  'checkout.loading': 'Fizetés betöltése...',
  'checkout.iframeTitle': 'Szolgáltató fizetési felülete',
  'checkout.widgetTitle': 'Fizetési folyamat',
  'checkout.unknownMethod': 'Ismeretlen fizetési módszer',
  'processing.default': 'Rendelés feldolgozása...',
  'processing.pending': 'Várakozás a fizetés jóváhagyására...',
  'processing.active': 'Tranzakció feldolgozása...',
  'processing.generic': 'Feldolgozás...',
  'processing.checkingStatus': 'Állapot ellenőrzése...',
  'processing.orderId': 'Rendelésazonosító',
  'processing.provider': 'Szolgáltató',
  'processing.amount': 'Összeg',
  'processing.receiving': 'Fogadott összeg',
  'processing.network': 'Hálózat',
  'processing.toAddress': 'Cél cím',
  'processing.usuallyMinutes': 'Ez általában néhány percet vesz igénybe.',
  'processing.safeToClose': 'Nyugodtan bezárhatja ezt az oldalt – e-mailben értesítjük, ha a folyamat befejeződött.',
  'complete.buyTitle': 'Vásárlás sikeres!',
  'complete.sellTitle': 'Eladás sikeres!',
  'complete.buyDesc': 'A(z) {crypto} el lett küldve a tárcájába.',
  'complete.sellDesc': '{fiat} kifizetése folyamatban van.',
  'complete.amountBuy': 'Fogadott összeg',
  'complete.amountSell': 'Eladott összeg',
  'complete.paidBuy': 'Fizetett összeg',
  'complete.paidSell': 'Kifizetett összeg',
  'complete.network': 'Hálózat',
  'complete.wallet': 'Tárca',
  'complete.transaction': 'Tranzakció',
  'complete.provider': 'Szolgáltató',
  'complete.orderId': 'Rendelésazonosító',
  'complete.completed': 'Befejezve',
  'complete.viewExplorer': 'Megtekintés a böngészőben',
  'complete.done': 'Kész',
  'errorStep.failed': 'A fizetés sikertelen',
  'errorStep.cancelled': 'Rendelés törölve',
  'errorStep.expired': 'A rendelés lejárt',
  'errorStep.refunded': 'Rendelés visszatérítve',
  'errorStep.unknown': 'Valami hiba történt',
  'errorStep.failedBuy': 'A fizetés nem dolgozható fel. Kérjük, próbálja újra, vagy használjon másik fizetési módot.',
  'errorStep.failedSell': 'Az eladás nem dolgozható fel. Kérjük, próbálja újra.',
  'errorStep.cancelledBuy': 'A rendelése törölve lett. Nem történt fizetési tranzakció.',
  'errorStep.cancelledSell': 'Az eladása törölve lett. Nem történt kriptoátutalás.',
  'errorStep.expiredBuy': 'A rendelése lejárt. Kérjük, kezdjen új vásárlást.',
  'errorStep.expiredSell': 'A rendelése lejárt. Kérjük, kezdjen új eladást.',
  'errorStep.refundedBuy': 'A fizetése visszatérítésre került. Az összeg 5-10 munkanapon belül megjelenik a számláján.',
  'errorStep.refundedSell': 'A kriptója visszaküldésre került. Az összeg hamarosan megjelenik a tárcájában.',
  'errorStep.genericDesc': 'Váratlan hiba történt. Kérjük, próbálja újra.',
  'errorStep.orderId': 'Rendelésazonosító',
  'errorStep.tryAgain': 'Újra próbálom',
  'errorStep.startOver': 'Kezdje elölről',
  'errorStep.return': 'Visszatérés',
  'errorStep.needHelp': 'Segítségre van szüksége? Lépjen kapcsolatba: ',
  'errorStep.reference': 'Hivatkozási szám: {orderId}',
  'confirm.buyTitle': 'Vásárlás megerősítése',
  'confirm.sellTitle': 'Eladás megerősítése',
  'confirm.loading': 'Betöltés...',
  'confirm.provider': 'Szolgáltató',
  'confirm.youPay': 'Ön fizet',
  'confirm.youSell': 'Ön elad',
  'confirm.youReceive': 'Ön kap',
  'confirm.wallet': 'Tárca',
  'confirm.network': 'Hálózat',
  'confirm.refundAddress': 'Visszatérítési cím',
  'confirm.parityNote': 'A szolgáltató által terhelt összeg eltérhet. A fennmaradó {amount} {crypto} a {partner} fiókjára kerül jóváírásra.',
  'confirm.processing': 'Feldolgozás...',
  'confirm.confirmPay': 'Megerősítés és fizetés',
  'confirm.confirmSell': 'Megerősítés és eladás',
  'confirm.payout': '{currency} kifizetés',
  'modal.selectFiat': 'Válasszon fiat devizát',
  'modal.selectCrypto': 'Válasszon kriptovalutát',
  'modal.choosePayment': 'Válasszon fizetési módot',
  'modal.selectCountry': 'Válassza ki az országát',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Népszerű',
  'modal.recommended': 'Ajánlott',
  'modal.noCurrencies': 'Nem található deviza',
  'modal.noPaymentMethods': 'Nem található fizetési mód',
  'modal.noCountries': 'Nem található ország',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Helyszín',
  'settings.darkMode': 'Sötét mód',
  'settings.privacy': 'Adatvédelmi irányelvek',
  'settings.terms': 'Felhasználási feltételek',
  'settings.language': 'Nyelv',
  // ─── Additional ───
  'modal.chooseRamp': 'Ramp kiválasztása',
  'modal.bestPrice': 'Legjobb ár',
  'modal.noQuotes': 'Ehhez a kéréshez nem érhető el ajánlat',
  'modal.noProvidersFound': 'Nem található szolgáltató',
  'payment.unavailableFor': 'Nincs elérhető fizetési mód a(z) {currency} devizához',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'A rendelés létrehozása sikertelen',
  'errorStep.returnToMerchant': 'Visszatérés a kereskedőhöz',
  'confirm.cryptoOnNetwork': '{crypto} a(z) {network} hálózaton',
  'payment.name.card': 'Kártya',
  'payment.name.bankTransfer': 'Banki átutalás',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default hu;
